module.exports = (__webpack_require__(/*! dll-reference dll_2a2042332c40652b2b37 */ "dll-reference dll_2a2042332c40652b2b37"))("./node_modules/react/index.js");